module.exports = __webpack_public_path__ + "img/serviceLine.311b07f0.svg";